import * as arrUtils from '../util/array';
import { osHasReducedMotion } from '../util/a11y';

/**
 * Loop Animation for Words with slide effect
 *
 * The animation fires on elements that following class structure:
 * <h1 class="text-anim text-anim--slide js-text-anim">
 *  <span>Regular Text</span>
 *  <span class="text-anim__wrapper">
 *    <strong class="text-anim__word js-text-anim__word text-anim__word--in">text to be</strong>
 *    <strong class="text-anim__word js-text-anim__word">animated</strong>
 *    <strong class="text-anim__word js-text-anim__word">one by one</strong>
 *  </span>
 * </el>
 */
 class TextAnimate {
  constructor (element) {
    this.element = element;
    this.words = this.element.querySelectorAll('.js-text-anim__word');
    // interval between two animations
    this.loopInterval = parseFloat(getComputedStyle(this.element).getPropertyValue('--text-anim-pause'))*1000 || 1000;
    // duration of single animation (e.g., time for a single word to rotate)
    this.transitionDuration = parseFloat(getComputedStyle(this.element).getPropertyValue('--text-anim-duration'))*1000 || 1000;
    this.wordInClass = 'text-anim__word--in';
    this.wordOutClass = 'text-anim__word--out';

    this.init();
  }

  init() {
    setTimeout(() => {this.process(this.firstWord, this.words)}, this.loopInterval);
  }

  get firstWord() {
    return this.words.item(0);
  }

  getNextWord(word) {
    return arrUtils.isLast(this.words, word) ? this.firstWord : word.nextElementSibling;
  }

  process(word) {
    this.switchWord(word, this.getNextWord(word));
    setTimeout(() => {this.process(this.getNextWord(word), this.words)}, this.loopInterval);
  }

  switchWord(oldWord, nextWord) {
    oldWord.classList.remove(this.wordInClass);
    oldWord.classList.add(this.wordOutClass);
    nextWord.classList.remove(this.wordOutClass);
    nextWord.classList.add(this.wordInClass);
  }
}

export default function() {
  // Do not start if motion is reduced based on client OS settings
  if ( false === osHasReducedMotion() ) {
    let headings = document.querySelectorAll('.js-text-anim');
    headings.forEach(el => {
      new TextAnimate(el);
    });
  }
}
